<auth id="auth-module"
      class="hidden"
      [isModal]="false"
      [isRegistrationDisabled]="true"
      [image]="conf.assetsUrl + 'img/app-logo_color.png'">
</auth>
<full-screen-loader id="full-screen-loader"></full-screen-loader>
